export default __webpack_public_path__ + "static/media/Background_00018.a9d4837b.png";